import * as terminalTransactionActions from '../actions/terminal-transactions.actions';
import { TerminalTransactionModel } from 'app/models/terminal-transaction-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  terminalTransactions: TerminalTransactionModel[];
  totalTerminalTransactions: number;
  isLoading: boolean;
  isLoaded: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  terminalTransactions: [],
  totalTerminalTransactions: 0,
  isLoading: false,
  isLoaded: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(terminalTransactionActions.loadTerminalTransactions, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    terminalTransactionActions.loadTerminalTransactionsSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      terminalTransactions: response.results,
      totalTerminalTransactions: response.count,
    })
  ),
  on(terminalTransactionActions.updateTerminalTransaction, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    terminalTransactionActions.updateTerminalTransactionSuccess,
    terminalTransactionActions.updateTerminalTransactionFailure,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(setActiveCompany, (state: State) => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
